export class User {
    public id: number;
    public first_name: string;
    public last_name: string;
    public phone: string;
    public phone_number: string;
    public email: string;
    public position: string;
    public permission: string;
    public special_requests: string;
    public grant_type: string = "password";
    public admin: boolean = false;
    public employee_number: string;
    public health_benefits: string;
    public last_sign_in_at: any;
    public company_name: string;

    static toUser(json) {
      let user = new User();
      return (<any>Object).assign(user, JSON.parse(json.user));
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/classes/user.ts